import { render, staticRenderFns } from "./jingxuan.vue?vue&type=template&id=1b1850d3&scoped=true&"
import script from "./jingxuan.vue?vue&type=script&lang=js&"
export * from "./jingxuan.vue?vue&type=script&lang=js&"
import style0 from "./jingxuan.vue?vue&type=style&index=0&id=1b1850d3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b1850d3",
  null
  
)

export default component.exports